'use client';

import EditorImg from 'lowcode/components/EditorImg';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { fetchPost } from 'lowcode/utils/service/FetchClient';
import { loginUrl } from 'lowcode/utils/service/baseUrl';
import { message } from 'antd';
import styles from '../index.module.scss';
import IconClose from './IconClose';
import { tranText } from './tranText';
import getLocal from '@/app/utils/getLocal';

export default function WinItem({ isExchange, activeType, data = {}, winItemCallback }: any) {
    const { locale } = getLocal();
    const textObj = tranText[locale] || tranText['us'];
    const [isClient, setIsClient] = useState(false);
    useEffect(() => {
        setIsClient(true);
    }, []);
    const closeHandle = () => {
        winItemCallback && winItemCallback('close');
    };

    const submitHandle = async () => {
        const params = {
            ruleId: data.ruleId,
            ruleVersion: data.version,
            ruleSiteVersion: data?.ruleWebsite?.version,
        };
        const res = await fetchPost(`${loginUrl(locale)}/integral/web/rewardRedeemCoupon/redeem`, locale, params, {
            needToken: true,
        });
        if (res.code === '0') {
            const data = res.data || {};
            winItemCallback && winItemCallback('confirm', data);
            message.success(res.message);
        }
    };

    if (isClient) {
        return ReactDOM.createPortal(
            <div className={`glo-editor-modal glo-editor-modal-show ${styles['eco-win']}`}>
                <div className={`glo-editor-modal-content scrollbar-editor-white eco-redeem-rewards-winitem ${styles.content}`}>
                    <div className="glo-editor-modal-header">
                        <IconClose onClick={closeHandle} />
                    </div>
                    <div className={`glo-editor-modal-body eco-redeem-rewards-winitem-${activeType}`}>
                        <div className="eco-redeem-rewards-card">
                            <div className="eco-redeem-rewards-card-img">
                                <EditorImg pc={data.rulePic} />
                                <div className="eco-redeem-rewards-card-amount">
                                    <div className="eco-redeem-rewards-card-amount-l">
                                        <div className="eco-redeem-rewards-card-amount-line1">
                                            <span className="eco-redeem-rewards-card-amount-line1-a">{data?.ruleWebsite?.amount}&nbsp;</span>
                                            <span className="eco-redeem-rewards-card-amount-line1-b">{data?.ruleWebsite?.currencySymbol}</span>
                                        </div>
                                        <div className="eco-redeem-rewards-card-amount-line2">{textObj?.card_off}</div>
                                    </div>
                                    {data?.prerequisiteRange && (
                                        <div className="eco-redeem-rewards-card-amount-r">
                                            {textObj?.card_price_tips}
                                            {['uk', 'eu'].includes(locale)
                                                ? data?.ruleWebsite?.currencySymbol + data?.prerequisiteRange
                                                : data?.prerequisiteRange + data?.ruleWebsite?.currencySymbol}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="eco-redeem-rewards-card-desc">
                                <div className="eco-redeem-rewards-card-desc1">{data?.goodTitle || textObj.card_discount_code}</div>
                                <div className="eco-redeem-rewards-card-desc2">
                                    {data?.points}&nbsp;
                                    {textObj.card_credits}
                                </div>
                            </div>
                        </div>
                        <div className="eco-redeem-rewards-winitem-note">
                            <div className="eco-redeem-rewards-winitem-title">
                                {textObj.card_rules}
                                {data.noteList.map((item: string) => (
                                    <p key={item}>{item}</p>
                                ))}
                            </div>
                            <div
                                className="eco-redeem-rewards-winitem-desc"
                                dangerouslySetInnerHTML={{
                                    __html: data.ruleDescription,
                                }}
                            ></div>
                        </div>
                        {isExchange && (
                            <>
                                <div className="eco-redeem-rewards-winitem-tips">{textObj.win_item_desc}</div>
                                <div className="eco-redeem-rewards-winitem-confirm" onClick={submitHandle}>
                                    {textObj.win_item_btn}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>,
            document.body,
        );
    }
    return null;
}
